"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _modal = _interopRequireDefault(require("./modal"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

const DEFAULT_STATE = {
  passphrase: ''
};
const ERROR = 'Used denied to enter passpharse';

class InputPassphrase extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onClose", () => {
      this.setState({
        visible: false
      }, () => {
        this.props.done(ERROR, null);
      });
    });

    _defineProperty(this, "handleSubmit", () => {
      this.setState({
        visible: false
      }, () => {
        if (!this.state.passphrase) return this.props.done(ERROR, null);
        return this.props.done(null, this.state.passphrase);
      });
    });

    _defineProperty(this, "onChange", e => {
      this.setState({
        passphrase: e.target.value
      });
    });

    this.state = _objectSpread({
      visible: this.props.visible
    }, DEFAULT_STATE);
  }

  componentWillUnmount() {
    // Clear history
    this.setState(_objectSpread({}, DEFAULT_STATE));
  }

  componentDidMount() {
    // Listen Enter button
    let input = document.getElementById('inputPassphrase');
    if (input) input.addEventListener('keyup', e => {
      if (e.keyCode === 13) this.handleSubmit();
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState(_objectSpread({
        visible: this.props.visible
      }, DEFAULT_STATE), () => {
        // Autofocus
        setTimeout(() => {
          if (this.passpharseName) this.passpharseName.focus();
        }, 1);
      });
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: this.state.visible,
      className: cx("fade", "wallet-modal", "enter-passphrase"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: () => {
        this.onClose();
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Input Your Passphrase"), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-inline")
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "passphrase"
    }, "Passphrase"), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-group")
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "password",
      id: "passphrase",
      className: cx("form-control", "col-12", "col-xl-8", "col-lg-8", "col-md-8", "col-sm-12", "mr-4", "ml-0"),
      value: this.state.passphrase,
      onChange: this.onChange,
      ref: name => {
        this.passpharseName = name;
      }
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-primary", "btn-sm", "col-3"),
      onClick: this.handleSubmit
    }, "OK")))));
  }

}

var _default = InputPassphrase;
exports.default = _default;